<template>
  <OfficialWebsite />
</template>
<script>
import OfficialWebsite from '@/views/OfficialWebsite.vue';

export default {
  name: 'App',
  components: {
    OfficialWebsite
  }
}
</script>

<style>
/*#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}*/
@import './assets/styles/main.scss';

</style>
